import { Component } from "@angular/core";

import { DialogServiceService } from "src/app/_app-core/dialogs/dialog-service.service";
import { JswVmdService } from "src/app/_app-core/services/jsw-vmd/jsw-vmd.service";

/**
 * Inline banner shown on /change-requests pages when the JSW access token
 * is no longer usable. Reads the auth-failed flag from `JswVmdService`
 * and lets the user replay the post-login sequence (apiAuthToken + the two
 * getApiRequestResultsData calls) via the Re-authenticate button.
 *
 * On success the service clears its own flag, which collapses this banner
 * and lets the parent pages resume their normal load. On failure we surface
 * an error modal and leave the banner visible so the user can retry.
 */
@Component({
  selector: "app-jsw-auth-banner",
  templateUrl: "./jsw-auth-banner.component.html",
  styleUrls: ["./jsw-auth-banner.component.scss"],
})
export class JswAuthBannerComponent {
  busy = false;

  readonly jswAuthFailed$ = this.jsw.jswAuthFailed$;

  constructor(
    private jsw: JswVmdService,
    private dialogs: DialogServiceService,
  ) {}

  onReauthenticate(): void {
    if (this.busy) {
      return;
    }
    const vendorCode = (localStorage.getItem("vendorCode") || "").trim();
    if (!vendorCode) {
      this.dialogs.showErrorModal(
        "Vendor code is missing. Please log in again.",
      );
      return;
    }

    this.busy = true;
    this.jsw.reauthenticate(vendorCode).subscribe({
      next: () => {
        this.busy = false;
      },
      error: (err) => {
        console.error("JSW re-authentication failed", err);
        this.busy = false;
        this.dialogs.showErrorModal(
          "Re-authentication failed, please try again.",
        );
      },
    });
  }
}
